﻿
type SwaggerCtor<T> = Function & { prototype: T, fromJS(data: any): T };

/**
 * Register derived types with its base class(es) so that data is properly deserialised.
 * @param BaseClass the base swagger generated class
 * @param derivedClasses [string]:class map of derived types.
 * @deprecated If we still need this with the new apis then we need to investigate why and how otherwise use the authorizedClientBase
 */
export function AddKnownTypes<T>(BaseClass: SwaggerCtor<T>, derivedClasses: { [key: string]: SwaggerCtor<T> }) {

    // Store original fromJS function
    const fromJS = BaseClass.fromJS;

    if (!fromJS) {
        throw new Error("Msg.Swagger: Base class does not appear to be a swagger generated class, missing static '.fromJS' method.");
    }

    // Overrides base class fromJS function
    BaseClass.fromJS = function (data: any) {
        data = typeof data === 'object' ? data : {};

        // Try to find the class name in the json object, 'discriminator' or '$type'
        let className = "";
        if (data["discriminator"]) {
            className = data["discriminator"];
        } else if (data["$type"]) {
            const cls = data["$type"].split(",")[0];
            if (cls) className = cls.split(".").pop();
        } else if (data["type"]) {
            const cls = data["type"].split(",")[0];
            if (cls) className = cls.split(".").pop();
        }

        // if a classname was found, see if we have its constructor and use that
        if (className) {
            const Ctor = derivedClasses[className];
            if (Ctor) return Ctor.fromJS(data);
        }

        // if nothing matching was found, call the original/parent fromJS function
        return fromJS(data);
    };

    // Traverse up the protype chain and add known types to any other swagger base classes
    const SuperBase = Object.getPrototypeOf(BaseClass.prototype).constructor;
    if (SuperBase && SuperBase.fromJS) {
        AddKnownTypes(SuperBase, derivedClasses);
    }

}

// Fix for angular clients
interface ngPromise<T> extends Promise<T> {
    finally(r: any): any;
}

/**
 * Base class for swagger clients, sets credential to same-origin for requests.
 * Required for Edge to send authentication cookies.
 */
export class ClientBase {
    transformOptions(options: RequestInit): ngPromise<any> {
        options.credentials = "same-origin";
        return new Promise(resolve => resolve(options)) as any;
    }
}
